
















import Vue from 'vue'
import { State } from 'vuex-class'
import { Component, Prop, Emit } from 'vue-property-decorator'

import { User } from '@/modules/User/interfaces/user'

@Component({
  components: {}
})
export default class MenuChecklist extends Vue {
  @Prop({ type: Number }) readonly left!: number
  @Prop({ type: Number }) readonly top!: number

  @State(state => state.user.me) me!: User

  async mounted () {

  }

  @Emit('hide')
  hide () {}

  @Emit('show-message')
  onMessageClick () {
    this.hide()
  }

  @Emit('show-sign-out')
  onSignOutClick () {
    this.hide()
  }
}
